/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="defaultModal modal hide ' +
__e( !!data.title ? 'hasTitle' : '') +
'" tabindex="-1" role="dialog" aria-hidden="true">\n  <div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>\n    ';
 if(data.title){ ;
__p += '\n      <h2>\n        ' +
__e(data.title) +
'\n      </h2>\n    ';
 } ;
__p += '\n  </div>\n  <div class="clear"></div>\n  <div class="modal-body">\n    ';
 data.each(data.inputs, function(input){ ;
__p += '\n      <div class="zfInputField">\n        <div class="zfLabel">\n          ' +
__e(input.key) +
'\n        </div>\n        <div class="zfInput">\n          ';
 if (input.options) { ;
__p += '\n            <select name="' +
__e(input.name) +
'">\n              ';
 data.each(input.options, function(option){ ;
__p += '\n                <option ' +
__e(option.value == input.value ?'selected="selected"':'') +
' value="' +
__e(option.value === null || typeof(option.value) === 'undefined' ? '' : option.value) +
'">\n                  ' +
__e(option.key) +
'\n                </option>\n              ';
 }) ;
__p += '\n            </select>\n          ';
 } else if(input.type && input.type == 'textarea') { ;
__p += '\n            <textarea name="' +
__e(input.name) +
'" ' +
((__t = (input.attrs || '')) == null ? '' : __t) +
' placeholder="' +
__e(input.placeholder) +
'">' +
__e(input.value === null || typeof(input.value) === 'undefined' ? '' : input.value) +
'</textarea>\n          ';
 } else { ;
__p += '\n            <input name="' +
__e(input.name) +
'" type="text" value="' +
__e(input.value === null || typeof(input.value) === 'undefined' ? '' : input.value) +
'" ' +
((__t = (input.attrs || '')) == null ? '' : __t) +
' ' +
((__t = (input.placeholder ? 'placeholder="'+input.placeholder+'"': '')) == null ? '' : __t) +
'/>\n          ';
 } ;
__p += '\n        </div>\n        ';
 if (input.note) { ;
__p += '\n          <div class="zfNote">' +
__e(input.note) +
'</div>\n        ';
 } ;
__p += '\n      </div>\n    ';
 }) ;
__p += '\n  </div>\n  <div class="modal-footer">\n    <div class="cancel-button" data-dismiss="modal" aria-hidden="true">\n      Cancel\n    </div>\n    <div class="main-modal-button submitFormModal">\n      ' +
__e(data.submitText) +
'\n    </div>\n  </div>\n</div>';
return __p
}
